import React, { useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import * as searchTypes from '../../../constants/searchTypes';
import * as select from '../../../extractFromState';
import { deleteSearchResultOfType, restoreSearchResultOfType } from '../../../actions/searchActions';
import {
  getHistoricalTicketSnippetIndex,
  getHistoricalTicketMessageSnippet,
  getHistoricalTicketSubjectSnippet,
  filterImgLinksfromString,
} from '../../../util/kbUtil';
import { setAnchorElementsTarget } from '../../../util';
import {
  SearchAllResult,
  SearchAllResultHeading,
  SearchAllResultTextContainer,
  SearchAllDate,
  SearchAllDeleteButton,
} from './Search.styles';

const TicketSearchResult = ({
  result,
  index,
  clickAction,
  isSpecialist,
  showUndo,
  undoDelete,
  trashResult,
  hideDeleteButton,
}) => {
  const [processing, setProcessing] = useState(false);

  const snippetIndex = getHistoricalTicketSnippetIndex(result);
  const messageDate = moment(result.firstMessageArrivedAt).format('MM/DD/YY');

  let snippetMessageHtml;
  let snippetSubjectHtml;
  const message = getHistoricalTicketMessageSnippet(result, snippetIndex);
  const subject = getHistoricalTicketSubjectSnippet(result, snippetIndex);

  if (message) {
    snippetMessageHtml = filterImgLinksfromString(message);
  }

  if (subject) {
    snippetSubjectHtml = filterImgLinksfromString(subject);
  }

  if (snippetSubjectHtml === 'N/A' || snippetSubjectHtml === 'internal note') {
    snippetSubjectHtml = null;
  }

  const getButtonLabel = () => {
    if (showUndo) {
      return 'Undo';
    } else if (processing) {
      return 'Processing...';
    }

    return 'Delete';
  };

  const deleteOrUndo = () => {
    if (showUndo) {
      setProcessing(true);
      undoDelete().then(() => {
        setProcessing(false);
      });
    } else {
      setProcessing(true);
      trashResult().then(() => {
        setProcessing(false);
      });
    }
  };

  if (snippetSubjectHtml !== null || snippetMessageHtml !== null) {
    return (
      <SearchAllResult>
        <SearchAllResultTextContainer onClick={() => clickAction(index, searchTypes.SEARCH_TICKETS)}>
          <SearchAllDate>{messageDate === 'Invalid date' ? '' : messageDate}</SearchAllDate>
          {snippetSubjectHtml && (
            <SearchAllResultHeading>
              Subject:&nbsp;
              <span dangerouslySetInnerHTML={{ __html: setAnchorElementsTarget(snippetSubjectHtml) }} />
            </SearchAllResultHeading>
          )}
          <SearchAllResultHeading>Message:&nbsp;</SearchAllResultHeading>
          <div dangerouslySetInnerHTML={{ __html: setAnchorElementsTarget(snippetMessageHtml) }} />
        </SearchAllResultTextContainer>
        {isSpecialist && !hideDeleteButton && (
          <SearchAllDeleteButton disabled={processing} onClick={() => deleteOrUndo()}>
            {getButtonLabel()}
          </SearchAllDeleteButton>
        )}
      </SearchAllResult>
    );
  }

  return null;
};

const mapStateToProps = (state, { result }) => ({
  isSpecialist: select.isSpecialist(state),
  showUndo: select.isSearchResultDeleted(state, result, searchTypes.SEARCH_TICKETS),
});

const mapDispatchToProps = (dispatch, { result }) => ({
  undoDelete: () => dispatch(restoreSearchResultOfType(result, searchTypes.SEARCH_TICKETS)),
  trashResult: () => dispatch(deleteSearchResultOfType(result, searchTypes.SEARCH_TICKETS)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TicketSearchResult);
